import GeneralLedger from "@/views/reports/accountingreport/GeneralLedger.vue";

const getters = {
    sales: (state) => state.sales,
    finished: (state) => state.finished,
    semi: (state) => state.semi,
    raw: (state) => state.raw,
    cost: (state) => state.cost,
    production: (state) => state.production,
    balancesheet: (state) => state.balancesheet,
    profitandloss: (state) => state.profitandloss,
    trialBalance: (state) => state.trialBalance,
    tds: (state) => state.tds,
    vatreturn: (state) => state.vatreturn,
    cashbook: (state) => state.cashbook,
    lead: (state) => state.lead,
    conversion: (state) => state.conversion,
    loading: state => state.loading,
    payrollVariance: state => state.payrollVariance,
    complaintResolutionTime: state => state.complaintResolutionTime,
    staffComplaintHandlingPerformance: state => state.staffComplaintHandlingPerformance,
    customerComplaintFrequency: state => state.customerComplaintFrequency,
    leadClientOpportunityCostSummary: state => state.leadClientOpportunityCostSummary,
    customerTicketVolumeAnalysis: state => state.customerTicketVolumeAnalysis,
    salesSummaryReport: state => state.salesSummaryReport,
    generalLedger: (state) => state.generalLedger,
    SalesValueContributionBySalesperson: (state) => state.SalesValueContributionBySalesperson,
    LeadAgingAnalysis: (state) => state.LeadAgingAnalysis,
    salesAnalyticsReport: state => state.salesAnalyticsReport,
    salesAnalyticsReportByProduct: state => state.salesAnalyticsReportByProduct,
    salesAnalyticsReportByClient: state => state.salesAnalyticsReportByClient,
    ticketCategoryReport: state => state.ticketCategoryReport,
    quotationPriorityReport: state => state.quotationPriorityReport,
    productionCostAnalysisReport: state => state.productionCostAnalysisReport,
    productionReport: state => state.productionReport,
    productionLeadTimeAnalysisReport: state => state.productionLeadTimeAnalysisReport,
    projectCostAnalysisReport: state => state.projectCostAnalysisReport,
    projectStatusReport: state => state.projectStatusReport,
    inventoryValueAnalysisReport: state => state.inventoryValueAnalysisReport,
    inventoryQtyAnalysisReport: state => state.inventoryQtyAnalysisReport,
    warehouseDistributionReport: state => state.warehouseDistributionReport,
    monthlySpendingByPlatform: state => state.monthlySpendingByPlatform,
    generalLedger: (state) => state.generalLedger
};

export default getters;